// extracted by mini-css-extract-plugin
export var isCompact = "L6ZqA";
export var isShowImage = "x8PgV";
export var root = "M6aDd";
export var subText = "VNY7r";
export var text = "MpPuD";
export var theme = "fkV52";